import { useState } from "react";
import { FaChevronDown, FaChevronUp, FaKey, FaLock, FaShieldAlt, FaFileAlt, FaCheckCircle } from "react-icons/fa";
import { Card, Badge } from "../../../../../_CORE/APP/Templates/_UI/Kit/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";

const STORAGE_KEY = "notebook-personal-vault-security-guide";

const STEPS = [
    {
        icon: <FaKey />, title: "Clave maestra", badge: "Crítico",
        text: "APP__DATA_ENCRYPTION_KEY debe ser larga, única y quedar solamente en el backend. Nunca la guardes dentro de la propia bóveda.",
    },
    {
        icon: <FaLock />, title: "PIN por grupo", badge: "Recomendado",
        text: "Usalo en grupos muy sensibles. El PIN nuevo se guarda con bcrypt, por lo que no puede recuperarse desde la base de datos.",
    },
    {
        icon: <FaShieldAlt />, title: "2 pasos", badge: "Recomendado",
        text: "Registrá qué autenticador usa la cuenta y los canales de recuperación. La semilla TOTP es opcional y queda cifrada.",
    },
    {
        icon: <FaCheckCircle />, title: "Códigos de recuperación", badge: "Muy útil",
        text: "Pegalos uno por línea. Se cifran, se revelan de a uno y podés tacharlos cuando ya fueron utilizados.",
    },
    {
        icon: <FaFileAlt />, title: "Archivos de emergencia", badge: "Cifrado",
        text: "Podés adjuntar kits de recuperación, certificados o archivos de clave. Los nuevos adjuntos se cifran antes de guardarse en disco.",
    },
];

export const PersonalVaultSecurityGuide = () => {
    const [useOpen, setOpen] = useState(() => {
        try {
            const stored = window.localStorage.getItem(STORAGE_KEY);
            return stored == null ? false : stored === "1";
        } catch {
            return false;
        }
    });

    const onToggle = () => {
        setOpen((prev) => {
            const next = !prev;
            try { window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0"); } catch {}
            return next;
        });
    };

    return (
        <Card className="LStudio__app_vault_security_guide">
            <div className="LStudio__app_vault_security_guide_head">
                <div>
                    <span className="LStudio__app_vault_security_guide_eyebrow">SEGURIDAD DE LA BÓVEDA</span>
                    <h3>Cómo guardar secretos reales sin perderte</h3>
                    <p>
                        La bóveda separa datos visibles de secretos cifrados. Esta guía queda disponible para recordar
                        qué conviene cargar y qué no.
                    </p>
                </div>
                <AppButton size="sm" variant="ghost" tone="neutral"
                    icon={useOpen ? <FaChevronUp /> : <FaChevronDown />} onClick={onToggle}>
                    {useOpen ? "Ocultar guía" : "Ver guía"}
                </AppButton>
            </div>

            {useOpen && (
                <>
                    <div className="LStudio__app_vault_security_steps">
                        {STEPS.map((step, index) => (
                            <div key={step.title} className="LStudio__app_vault_security_step">
                                <div className="LStudio__app_vault_security_step_icon">{step.icon}</div>
                                <div className="LStudio__app_vault_security_step_body">
                                    <div className="LStudio__app_vault_security_step_title">
                                        <span>{index + 1}. {step.title}</span>
                                        <Badge size="sm" tone={index === 0 ? "danger" : "accent"}>{step.badge}</Badge>
                                    </div>
                                    <p>{step.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="LStudio__app_vault_security_notice">
                        <strong>Regla práctica:</strong> contraseña, PIN de la cuenta, token, semilla TOTP y notas de seguridad
                        van en campos cifrados. Las notas comunes sirven sólo para contexto. En producción usá siempre HTTPS.
                    </div>
                </>
            )}
        </Card>
    );
};
